import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AnnualReportStep, AutofillOptions } from '@modeso/types__aumico-lib-annualreport-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { cloneDeep } from 'lodash-es';
import { ProjectToCopyFrom } from '../../interfaces/project-to-copy-from.interface';
@UntilDestroy()
@Component({
    selector: 'aumico-annualReport-project-selection-list-component',
    templateUrl: 'project-selection-list.component.html',
    styleUrls: ['project-selection-list.component.scss'],
})
export class ProjectSelectionListComponent implements OnInit {
    filteredProjects: ProjectToCopyFrom[] = [];
    annualReportAutofillOptions: FormGroup;
    @Input() currentLanguage: 'de-ch';
    @Input() showAutofillOptions: boolean;
    @Input() activeArNavigation: AnnualReportStep[];
    @Input() autofillOptions: Record<AutofillOptions, string>;
    @Input() selectedAnnualReportIdToAutofillFrom: string;
    private originalProjects: ProjectToCopyFrom[] = [];
    @Input() set data(value: { projects: ProjectToCopyFrom[] }) {
        this.originalProjects = cloneDeep<ProjectToCopyFrom[]>(value.projects);
        this.filteredProjects = cloneDeep<ProjectToCopyFrom>(value.projects);
    }

    @Output() rowSelected = new EventEmitter<string>();
    @Output() selectedOptions = new EventEmitter<AutofillOptions[]>();
    selectedProjectForUploadAndMappingAutoFill: ProjectToCopyFrom;

    ngOnInit(): void {
        this.annualReportAutofillOptions = new FormGroup({
            taxonamy: new FormControl(true),
            notes: new FormControl(false),
            cashflow: new FormControl(false),
            aop: new FormControl(false),
        });

        if (this.autofillOptions != null) {
            this.selectedProjectForUploadAndMappingAutoFill = this.originalProjects.find(
                (project) => project.annualReportEncryptedId === this.autofillOptions.taxonamy,
            );
            this.annualReportAutofillOptions.get('taxonamy').setValue(true);
            this.annualReportAutofillOptions.get('notes').setValue(this.autofillOptions.notes);
            this.annualReportAutofillOptions.get('cashflow').setValue(this.autofillOptions.cashflow);
            this.annualReportAutofillOptions.get('aop').setValue(this.autofillOptions.aop);
        }

        this.annualReportAutofillOptions.get('taxonamy').disable();

        this.annualReportAutofillOptions.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
            const formValue = this.annualReportAutofillOptions.getRawValue();
            const selectedOptions = Object.keys(formValue).filter((key) => formValue[key]) as AutofillOptions[];
            this.emitSelectedOptions(selectedOptions);
        });
    }

    onRowSelected(project: ProjectToCopyFrom): void {
        this.rowSelected.emit(project.annualReportEncryptedId);
    }

    filterProjects(searchTerm: string | null): void {
        if (searchTerm === null) {
            this.filteredProjects = this.originalProjects || [];
            return;
        }

        this.filteredProjects = (this.originalProjects || []).filter(
            (project) =>
                (project.companyName?.toLowerCase().includes(searchTerm.toLowerCase()) ?? false) ||
                (project.legalForm?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ?? false) ||
                (project.accountingBasis?.text?.[this.currentLanguage]
                    ?.toLowerCase()
                    .includes(searchTerm.toLowerCase()) ??
                    false),
        );
    }

    private emitSelectedOptions(selectedOptions: AutofillOptions[]) {
        this.selectedOptions.emit(selectedOptions);
    }
}
